import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import autoUploadBackgroundImage from 'img/family-content/empty-new-block-family-auto-upload.png';
import React, { type ReactElement, useEffect } from 'react';
import { renderAutoUploadModal } from 'reactApp/ui/AutoUploadModal';
import baseStyles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FamilyContentNewEmptyCards.css';

// определяет тип фримиума для аналитики
const getFreemiumTypeForAnalytics = (): 'soft' | 'hard' | 'trial' => {
    const freemiumTypeParam = getFeature('freemium-type') as 'soft' | 'hard' | undefined;
    if (freemiumTypeParam === 'soft') {
        return 'soft';
    }
    if (freemiumTypeParam === 'hard') {
        return 'hard';
    }
    return 'trial';
};

// получает имя для аналитики автозагрузки из эмптистейта
const getAutoUploadEmptyAnalyticsName = (): string => {
    const type = getFreemiumTypeForAnalytics();
    if (type === 'soft') {
        return 'unlimited_auto_download_soft_freemium';
    }
    if (type === 'hard') {
        return 'unlimited_auto_download_hard_freemium';
    }
    return 'unlimited_auto_download_trial';
};

export const FamilyAutoUpload = (): ReactElement => {
    const analyticsName = getAutoUploadEmptyAnalyticsName();

    const onClick = () => {
        sendDwh({
            eventCategory: 'empty-family',
            action: 'click',
            p: 'cloud-web-analytics',
            dwh_enabled: true,
            dwhData: { name: analyticsName },
        });
        renderAutoUploadModal();
    };

    useEffect(() => {
        sendDwh({
            eventCategory: 'empty-family',
            action: 'show',
            p: 'cloud-web-analytics',
            dwh_enabled: true,
            dwhData: { name: analyticsName },
        });
    }, [analyticsName]);

    return (
        <div
            id="family-card-auto-upload"
            className={`${baseStyles.card} ${styles.autoUpload}`}
            onClick={onClick}
            data-qa-id="family-auto-upload"
        >
            <Title level="2" data-qa-id="family-auto-upload-title">
                Храните&nbsp;фото&nbsp;безлимитно
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-auto-upload-content">
                Фото с телефона весят 0 ГБ в Облаке.
                <br />
                Для безлимита у каждого личная папка
            </Text>
            <Spacing size={20} style={{ pointerEvents: 'none' }} />
            <img src={autoUploadBackgroundImage} alt="Безлимитная автозагрузка фото с телефона" className={styles.image} />
            <Button
                mode="primary"
                appearance="accent-invariable"
                size="l"
                className={styles.button}
                data-qa-id="family-auto-upload-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                Как это работает
            </Button>
        </div>
    );
};
